import { CardLoader } from 'components/organisms'
import ProductStatusBadge from 'domains/product/atoms/product-status-badge'
import ProductDetailView from 'domains/product/molecules/view/product-detail-view'
import ProductImageCarousel from 'domains/product/molecules/image-carousel/product-image-carousel'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Button, Table } from 'reactstrap'
import StringUtil from 'utils/string-util'
import StringUtils from 'utils/string-util'
import ToggleCheckBox from 'components/molecules/toggle-check-box/toggle-check-box'

const propTypes = {
  product                         : PropTypes.object,
  className                       : PropTypes.string,
  isRefundEditable                : PropTypes.bool,
  onRefundableClick               : PropTypes.func,
  onNonrefundableReasonsEditClick : PropTypes.func
}

const defaultValues = {
  isRefundEditable                : false,
  onRefundableClick               : () => { },
  onNonrefundableReasonsEditClick : () => {}
}

/**
 * Multi-purpose product view.
 * It display about the product information
 * @param {object} product
 * @param {boolean} isRefundEditable - To display editable for is_refundable and nonrefunadable_reasons
 * @param {function} onRefundableClick - Handler for Toggle isRefundable on click
 * @param {function} onNonrefundableReasonsEditClick - Handler for button edit on Nonrefundable reasons
 */
const ProductView        = ({
  product,
  isRefundEditable,
  onRefundableClick,
  onNonrefundableReasonsEditClick
}) => (
  <>
    <div className='p-3'>
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          <div className='small text-uppercase text-light font-weight-bolder'>
            { 'Product' }
          </div>
          <h2 className='mb-0'>{ product.name }</h2>
        </div>
        <ProductStatusBadge product_status={ product.status } />
      </div>
    </div>

    <div className={ 'row row-cols-3 px-3' }>
      <div className='col'>
        <ProductImageCarousel
          style={{ width: '100%' }}
          images={ product.images }
          altText={ product.name }
        />
      </div>

      { /** Product (main information) */ }
      <div className='col'>
        <Table
          bordered
          hover
          size='sm'
          responsive
        >
          <tbody>
            <tr>
              <th scope='row'>ID</th>
              <td>{ product.id }</td>
            </tr>
            <tr>
              <th scope='row'>SKU</th>
              <td>{ product.sku }</td>
            </tr>
            <tr>
              <th scope='row'>Name</th>
              <td className='text-wrap'>{ product.name }</td>
            </tr>
            <tr>
              <th scope='row'>Product Type</th>
              <td>
                { product.productable_type }
              </td>
            </tr>
            <tr>
              <th scope='row'>Price</th>
              <td>{ StringUtils.currencyCase(product.price) }</td>
            </tr>
            <tr>
              <th scope='row'>Selling Price</th>
              <td>
                { StringUtils.currencyCase(product.selling_price) }
              </td>
            </tr>
            <tr>
              <th scope='row'>Discount %</th>
              <td>
                { (product.discount_percentage * 100) }{ '%' }
              </td>
            </tr>
            <tr>
              <th scope='row'>Quantity</th>
              <td>{ product.quantity }</td>
            </tr>
            <tr>
              <th scope='row'>On Hold Quantity</th>
              <td>{ product.on_hold_quantity }</td>
            </tr>
            <tr>
              <th scope='row'>Is in Stock</th>
              <td>{ String(product.is_in_stock) }</td>
            </tr>
            {
              isRefundEditable ? (
                <>
                  <tr>
                    <th scope='row'>{ 'Is Refundable' }</th>
                    <td>
                      <ToggleCheckBox
                        data = { product }
                        value={ product.is_refundable }
                        onChange={ () => {onRefundableClick({ isRefundable: !product.is_refundable })} }
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className='text-wrap' scope='row'>{ 'Nonrefundable reasons' }</th>
                    <td className='text-wrap d-flex justify-content-between'>
                      <div>
                        { product.nonrefundable_reasons }
                      </div>
                      <div>
                        <Button
                          onClick={ onNonrefundableReasonsEditClick }
                          color='primary'
                          disabled={ product.is_refundable }
                        >
                          { 'Edit' }
                        </Button>
                      </div>
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  <tr>
                    <th scope='row'>Is Refundable</th>
                    <td>{ product.is_refundable ? String(product.is_refundable) : 'not set' }</td>
                  </tr>
                  <tr>
                    <th className='text-wrap' scope='row'>{ 'Nonrefundable reasons' }</th>
                    <td className='text-wrap'>{ product.nonrefundable_reasons }</td>
                  </tr>
                </>
              )
            }
            <tr>
              <th scope='row'>Is Deleted</th>
              <td>{ product.is_deleted ? String(product.is_deleted) : 'not set' }</td>
            </tr>
            <tr>
              <th scope='row'>Gender</th>
              <td>{ product.gender }</td>
            </tr>
            <tr>
              <th scope='row'>Live Date</th>
              <td>{ product.live_date ? product.live_date : 'not live' }</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className='col'>
        <Table
          bordered
          hover
          size='sm'
          className='col'
          responsive
        >
          <tbody>
            {
              product.details && Object.keys(product.details).map((detailKey, index) => (
                <tr key={ index }>
                  <th scope='row'>{ StringUtil.humanize(detailKey) }</th>
                  <td className='text-wrap'>
                    <ProductDetailView detail={ product.details[detailKey] } />
                  </td>
                </tr>
              ))
            }
          </tbody>
        </Table>
      </div>
    </div>
  </>
)
ProductView.propTypes    = propTypes
ProductView.defaultProps = defaultValues

export default withLoader(ProductView, CardLoader)
